module.exports = __webpack_public_path__ + "img/settings.7ddd8ec6.jpg";